import React, { Component } from 'react';
import project7 from '../images/project-7.png';
import project6 from '../images/project-6.png';
import project5 from '../images/project-5.png';
import project4 from '../images/project-4.png';
import project3 from '../images/project-3.png';
import project2 from '../images/project-2.png';
import project1 from '../images/project-1.png';
import rails from '../images/rails.png';
import redux from '../images/redux.ico';
import jest from '../images/jest.ico';
import postgres from '../images/postgres.ico';
import rspec from '../images/rspec.png';
import heroku from '../images/heroku.ico';
import webpack from '../images/webpack.png';

class Projects extends Component {
  render() {
    return (
    <div className="condiv">
      <div className="projects">

        <div class="project">
          <h4>Recipe Catalogue</h4>
          <div class="project-details-hr">
            <h6 class="pl-3">Built with:</h6>
            <a><i class="fab fa-react"></i><span> React </span> </a>
            <a> <img className="icon" src={redux} /><span> Redux </span> </a>
            <a>
              <i class="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i class="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a> <img className="icon" src={jest} /><span> jest </span> </a>
            <a><i class="fas fa-cloud"></i> <span> API </span></a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/recipexapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              class="link"
              href="https://recipes-catelogue.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div class="image-container">
            <div class="mock-image-container">
              <img src={project7} />
            </div>
          </div>
        </div>

        <div class="project">
          <h4>Academic Hub</h4>
          <div class="project-details-hr">
            <h6 class="pl-3">Built with:</h6>
            <a><i class="fab fa-php"></i><span> PHP </span> </a>
            <a
              ><i class="fas fa-hockey-puck"></i>
              <span> MySQL </span>
            </a>
            <a>
              <i class="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i class="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a><i class="fab fa-wordpress"></i> <span> WordPress </span></a>
            <a
              class="link"
              href="https://academic-hub.000webhostapp.com/"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div class="image-container">
            <div class="mock-image-container">
              <img src={project6} />
            </div>
          </div>
        </div>
        <div className="project">
          <h4>Facebook clone</h4>
          <div className="project-details-hr">
            <h6 className="pl-3">Built with:</h6>
            <a> <img className="icon" src={rails} /><span> Rails </span> </a>
            <a
              ><img className="icon" src={postgres} />
              <span> Postgresql </span>
            </a>
            <a
              ><img className="icon" src={rspec} />
              <span> RSpec </span>
            </a>
            <a><i className="fas fa-gem"></i><span> Ruby </span></a>
            <a>
              <i className="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i className="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a><i className="fab fa-bootstrap"></i> <span> Bootstrap </span></a>
            <a><i className="fab fa-sass"></i> <span> SCSS </span></a>
            <a><img className="icon" src={heroku} /><span> Heroku </span></a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/facebook-clone"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              className="link"
              href="https://facebclone.herokuapp.com/"
              target="_blank"
              rel="noopener noreferrer"
              ><i className="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div className="image-container">
            <div className="mock-image-container">
              <img src={project4} />
            </div>
          </div>
        </div>
        <div className="project">
          <h4>React webpage</h4>
          <div className="project-details-hr">
            <h6 className="pl-3">Built with:</h6>
            <a> <i className="fab fa-react"></i><span> React </span> </a>
            <a><i className="fab fa-gulp"></i> <span> Gulp </span></a>
            <a>
              <i className="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i className="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a><i className="fab fa-bootstrap"></i> <span> Bootstrap </span></a>
            <a><i className="fab fa-sass"></i> <span> SCSS </span></a>
            <a><img className="icon" src={heroku} /><span> Heroku </span></a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/simple-react-web/tree/simple-react-app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              className="link"
              href="https://interior-designs.herokuapp.com/"
              target="_blank"
              rel="noopener noreferrer"
              ><i className="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div className="image-container">
            <div className="mock-image-container">
              <img src={project5} />
            </div>
          </div>
        </div>
        <div className="project">
          <h4>Restaurant Page</h4>
          <div className="project-details-hr">
            <h6 className="pl-3">Built with:</h6>
            <a> <i className="fab fa-js"></i><span> JavaScript </span> </a>
            <a><img className="icon" src={webpack} alt="webpack"/>
              <span> Webpack </span>
            </a>
            <a>
              <i className="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i className="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/restaurant-page"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              className="link"
              href="https://raw.githack.com/lekegitrepo/restaurant-page/restaurant-page/dist/index.html"
              target="_blank"
              rel="noopener noreferrer"
              ><i className="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div className="image-container">
            <div className="mock-image-container">
              <img src={project1} />
            </div>
          </div>
        </div>
        <div className="project">
          <h4>Weather App</h4>
          <div className="project-details-hr">
            <h6>Built with:</h6>
            <a> <i className="fab fa-js"></i><span> JavaScript </span> </a>
            <a><img className="icon" src={webpack} alt="webpack"/>
              <span> Webpack </span>
            </a>
            <a>
              <i className="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i className="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/weather-app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              className="link"
              href="https://raw.githack.com/lekegitrepo/weather-app/development/dist/index.html"
              target="_blank"
              rel="noopener noreferrer"
              ><i className="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div className="image-container">
            <div className="mock-image-container">
              <img src={project2} />
            </div>
          </div>
        </div>
        <div className="project">
          <h4>Tic-Tac-Toe</h4>
          <div className="project-details-hr">
            <h6>Built with:</h6>
            <a> <i className="fab fa-js"></i><span> JavaScript </span> </a>
            <a>
              <i className="fab fa-css3"></i>
              <span>CSS3</span>
            </a>
            <a>
              <i className="fab fa-html5"></i>
              <span>HTML5</span>
            </a>
            <a
              className="link"
              href="https://github.com/lekegitrepo/Tic-Tac-Toe"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
              <span>source</span>
            </a>
            <a
              className="link"
              href="https://raw.githack.com/lekegitrepo/Tic-Tac-Toe/feature-branch/index.html"
              target="_blank"
              rel="noopener noreferrer"
              ><i className="fas fa-location-arrow"></i><span>demo</span></a
            >
          </div>
          <div className="image-container">
            <div className="mock-image-container">
              <img src={project3} />
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default Projects;
